import type { FunctionComponent } from "react";

const ImageIcon: FunctionComponent = () => (
  <svg
    className="support-icon"
    width={12}
    height={12}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M4 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9 0a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3h6ZM6.195 9.73 3.027 7.618l-2.013 1.61A2 2 0 0 0 3 11h6a2 2 0 0 0 2-2v-.77L8.16 5.795 6.196 9.73ZM3 1a2 2 0 0 0-2 2v4.959l1.974-1.578.304.203L5.806 8.27 7.84 4.203l3.162 2.71V3a2 2 0 0 0-2-2H3Z"
    />
  </svg>
);
export default ImageIcon;
